module.exports = __webpack_public_path__ + "static/media/instagram.ac31cef6.png";